import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const CustomSelect = ({
  name,
  options,
  formik,
  placeholder,
  handleChangeExtra,
}) => {
  return (
    <Select
      name={name}
      className="text-sm"
      classNamePrefix="react-select"
      options={options}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      value={options?.find((opt) => opt?.value === formik.values[name])}
      onChange={(selectedOption) => {
        formik.setFieldValue(name, selectedOption?.value || "");
        if (handleChangeExtra) handleChangeExtra(selectedOption);
      }}
      filterOption={(option, inputValue) =>
        option?.label?.toLowerCase().includes(inputValue.toLowerCase())
      }
      placeholder={placeholder}
      isClearable
      menuPlacement="auto"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: "35px",
          height: "auto",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
          boxShadow: state.isFocused ? "none" : "none",
          "&:hover": { borderColor: "#DFDFDF" },
          fontSize: "13px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: "#1E1E1E",
          padding: "0 14px",
          cursor: state.isDisabled ? "not-allowed" : "normal",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "auto",
          padding: "0 0px 0",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: "14px",
          height: "auto",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "14px",
          color: "#717680",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({
          ...base,
          marginTop: "2px",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: state.isSelected ? "#FFF" : "#1E1E1E",
          backgroundColor: state.isSelected
            ? "#3b82f6"
            : state.isFocused
            ? "#F3F4F6"
            : "#FFF",
          padding: "8px 14px",
          cursor: "pointer",
        }),
        indicatorContainer: (base) => ({ ...base, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
      }}
    />
  );
};
const AddHealthPriorityFlags = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  users = () => [],
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("flag", editData?.flag);
      formik.setFieldValue("column_name", editData?.column_name);
      formik.setFieldValue("operator", editData?.operator);
      formik.setFieldValue("column_value", editData?.column_value);
      formik.setFieldValue("visibility", editData?.visibility);
      formik.setFieldValue("is_active", editData?.is_active);

      if (editData?.visibility) {
        let valuesArray = [];

        if (Array.isArray(editData.visibility)) {
          valuesArray = editData.visibility.map((user) =>
            user?.usertypeid.toString()
          );
        } else if (typeof editData.visibility === "string") {
          valuesArray = editData.visibility.split(",").map((v) => v.trim());
        }

        formik.setFieldValue("visibility", valuesArray);
      }
    }
  }, [editData]);

  const category = [
    {
      key: "Open",
      value: "Open",
    },
    {
      key: "Closed",
      value: "Closed",
    },
    {
      key: "Working",
      value: "Working",
    },
    {
      key: "Hot",
      value: "Hot",
    },
    {
      key: "Won",
      value: "Won",
    },
    {
      key: "Lost",
      value: "Lost",
    },
  ];

  const typeArray = [
    {
      key: "Yes",
      value: 1,
    },
    {
      key: "No",
      value: 0,
    },
  ];

  const usersOptions = [
    { value: "all", label: "All" },
    ...(users?.map((each) => ({
      value: each.usertypeid.toString(),
      label: each.usertype,
    })) || []),
  ];

  const typeOptions = typeArray?.map((each) => ({
    value: each.value,
    label: each.key,
  }));

  const validationSchema = yup.object({
    flag: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    column_name: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    operator: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    column_value: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    visibility: yup
      .array()
      .of(yup.string())
      .min(1, "This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      flag: "",
      column_name: "",
      operator: "",
      column_value: "",
      visibility: [],
      is_active: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let data = {
        flag: values.flag,
        column_name: values.column_name,
        operator: values.operator,
        column_value: values.column_value,
        is_active: values?.is_active == 1 ? true : false,
        visibility: values.visibility.includes("all")
          ? "all"
          : values.visibility.join(","), // array → "2,3"
      };

      console.log("DATa", data);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `priority-flags/update-flag/${editData?.id}`
            : `priority-flags/add-flag`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  const isAllSelected = formik.values.visibility.includes("all");

  const selectedValuesArray = isAllSelected
    ? ["all"]
    : formik.values.visibility;

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{editData?.id ? "Edit Priority Flags" : "Add Priority Flags"}</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* flag */}
                  <FeildWraper>
                    <FormLabel required>Flag</FormLabel>
                    <input
                      type="text"
                      name="flag"
                      value={formik.values.flag}
                      onChange={formik.handleChange}
                      placeholder="flag"
                    />
                    {formik.touched.flag && formik.errors.flag && (
                      <FeildError>{formik.errors.flag}</FeildError>
                    )}
                  </FeildWraper>

                  {/* column_name */}
                  <FeildWraper>
                    <FormLabel required>Column Name</FormLabel>
                    <input
                      type="text"
                      name="column_name"
                      value={formik.values.column_name}
                      onChange={formik.handleChange}
                      placeholder="Column Name"
                    />
                    {formik.touched.column_name &&
                      formik.errors.column_name && (
                        <FeildError>{formik.errors.column_name}</FeildError>
                      )}
                  </FeildWraper>

                  {/* operator */}
                  <FeildWraper>
                    <FormLabel required>Operator</FormLabel>
                    <input
                      type="text"
                      name="operator"
                      value={formik.values.operator}
                      onChange={formik.handleChange}
                      placeholder="Operator"
                    />
                    {formik.touched.operator && formik.errors.operator && (
                      <FeildError>{formik.errors.operator}</FeildError>
                    )}
                  </FeildWraper>

                  {/* column_value */}
                  <FeildWraper>
                    <FormLabel required>Column Value</FormLabel>
                    <input
                      type="text"
                      name="column_value"
                      value={formik.values.column_value}
                      onChange={formik.handleChange}
                      placeholder="Column Value"
                    />
                    {formik.touched.column_value &&
                      formik.errors.column_value && (
                        <FeildError>{formik.errors.column_value}</FeildError>
                      )}
                  </FeildWraper>

                  {/* visibility */}
                  <FeildWraper>
                    <FormLabel required>Visibility</FormLabel>

                    <Select
                      name="visibility"
                      isMulti
                      className="text-sm"
                      classNamePrefix="react-select"
                      options={usersOptions}
                      components={{
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                      }}
                      /* Disable other options if All is selected */
                      isOptionDisabled={(option) =>
                        isAllSelected && option.value !== "all"
                      }
                      value={usersOptions.filter((option) =>
                        selectedValuesArray.includes(option.value)
                      )}
                      onChange={(selectedOptions) => {
                        const values =
                          selectedOptions?.map((opt) => opt.value) || [];

                        if (values.includes("all")) {
                          formik.setFieldValue("visibility", ["all"]);
                        } else {
                          formik.setFieldValue("visibility", values); // still array
                        }
                      }}
                      filterOption={(option, inputValue) =>
                        option.label
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      placeholder="Search or select users..."
                      isClearable
                      menuPlacement="auto"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "35px",
                          height: "auto",
                          borderRadius: "5px",
                          border: "1px solid #DFDFDF",
                          backgroundColor: state.isDisabled
                            ? "#f0f0f0"
                            : "#FFF",
                          boxShadow: state.isFocused ? "none" : "none",
                          "&:hover": { borderColor: "#DFDFDF" },
                          fontSize: "13px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: "#1E1E1E",
                          padding: "0 14px",
                          cursor: state.isDisabled ? "not-allowed" : "normal",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: "auto",
                          padding: "0 0px 0",
                          flexWrap: "wrap",
                          gap: "4px",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: "#E5E7EB",
                          borderRadius: "3px",
                          padding: "2px 6px",
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#1E1E1E",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: "#666",
                          ":hover": {
                            backgroundColor: "#D1D5DB",
                            color: "#000",
                          },
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: "14px",
                          lineHeight: "1.2",
                          fontWeight: 500,
                          color: state.isSelected ? "#FFF" : "#1E1E1E",
                          backgroundColor: state.isSelected
                            ? "#3b82f6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "#FFF",
                          padding: "8px 14px",
                          cursor: "pointer",
                        }),
                      }}
                    />
                    {formik.touched.visibility && formik.errors.visibility && (
                      <FeildError>{formik.errors.visibility}</FeildError>
                    )}
                  </FeildWraper>

                  {/* is_active */}
                  <FeildWraper>
                    <FormLabel required>Is Active</FormLabel>

                    <CustomSelect
                      name="is_active"
                      options={typeOptions}
                      formik={formik}
                      placeholder="Is Active"
                    />
                    {formik.touched.is_active && formik.errors.is_active && (
                      <FeildError>{formik.errors.is_active}</FeildError>
                    )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddHealthPriorityFlags;
